/**
 * Resource that represents a Movement.
 *
 * @name Movement
 * @class
 * @augments TmrResource
 */
function MovementFactory(TmrResource, tmrMovementTypes, Place) {
  'ngInject'
  let referencedProperties = [
    // item.originPlace property will be instantiated as a Place resource
    { property: 'originPlace', resource: Place },
    // item.destinationPlace property will be instantiated as a Place resource
    { property: 'destinationPlace', resource: Place },
  ]

  let Movement = TmrResource('Movement', {}, referencedProperties)

  Movement.getTypeDescription = getTypeDescription
  Movement.prototype.$getTypeDescription = getTypeDescription

  /**
   * Return Movement type description.
   *
   * @method Movement#getTypeDescription
   */
  function getTypeDescription() {
    return tmrMovementTypes[this.type]
  }

  return Movement
}

export const factory = ['Movement', MovementFactory]
